import styled from "styled-components";

import { mixins } from "@similarweb/styles";
import { Checkbox, FlexRow } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

export const StyledCheckboxFilterContainer = styled(Stack)`
    max-width: 263px;
    row-gap: 8px;
`;

export const StyledCheckboxFilterResultContainer = styled(FlexRow)`
    flex-wrap: wrap;
`;

export const StyledCheckboxFilterItem = styled(Checkbox)`
    label {
        ${mixins.setFontVariant("body1")};
    }
`;

export const StyledCheckboxFilterItemWrapper = styled.div`
    display: flex;
    align-items: center;
`;
